import { jsx } from "panel";
import { UserIconEl } from "common/widgets/user-icon";
import { Placement } from "common/components/tooltip/types";
import { TrackingEventProperty as UserIconTrackingEventProperty } from "common/widgets/user-icon/tracking";
import { TrackedUserIconEl } from "common/widgets/tracked-user-icon";
import { IconSizeType } from "common/constants";
import { TooltipEl } from "common/components/tooltip";
import { getEntityCreatorDisplayName } from "common/report/stores/user-details";
import { getLastViewedStr } from "./util";
import { isTrackedUserItem } from "./types";
import { TrackingEventProperty } from "./tracking";
function getIconEl(user, extraAttrs) {
  var _a;
  if (isTrackedUserItem(user)) {
    return /* @__PURE__ */ jsx(TrackedUserIconEl, {
      attrs: { ...user, ...extraAttrs }
    });
  } else {
    return /* @__PURE__ */ jsx(UserIconEl, {
      attrs: {
        ...user,
        ...extraAttrs,
        name: (_a = user.name) != null ? _a : ``
      }
    });
  }
}
function OverflowTooltip({
  users,
  extraUsersCount,
  moreText,
  editorUser,
  trackingProps,
  onShowed
}) {
  if (!users.length) {
    return null;
  }
  const hasLastViewed = users.some((user) => !isTrackedUserItem(user) && !!user.lastViewedUtcSeconds);
  const icons = users.map((user, index) => {
    const commonAttrs = {
      "disable-tooltip": true,
      size: IconSizeType.Small,
      "include-label": true,
      "track-properties": {
        [UserIconTrackingEventProperty.IconType]: index === 0 ? `creator` : `viewer`,
        [UserIconTrackingEventProperty.AccessPoint]: `views-overflow`,
        ...trackingProps ? {
          [UserIconTrackingEventProperty.Source]: trackingProps[TrackingEventProperty.Source],
          [UserIconTrackingEventProperty.ResourceType]: trackingProps[TrackingEventProperty.ResourceType]
        } : {}
      }
    };
    const rowNodes = [getIconEl(user, commonAttrs)];
    if (hasLastViewed && !isTrackedUserItem(user)) {
      const lastViewedStr = user.lastViewedUtcSeconds ? getLastViewedStr(user.lastViewedUtcSeconds) : ``;
      rowNodes.push(/* @__PURE__ */ jsx("div", {
        sel: ".secondary-text"
      }, lastViewedStr));
    }
    return /* @__PURE__ */ jsx("div", {
      sel: ".overflow-entry"
    }, rowNodes);
  });
  const editorUserName = editorUser && getEntityCreatorDisplayName(editorUser.email, editorUser.name);
  return /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { placement: Placement.Bottom },
    on: { showed: onShowed }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".overflow-users-list"
  }, hasLastViewed && /* @__PURE__ */ jsx("div", {
    sel: ".overflow-header.overflow-text"
  }, "Recently Viewed By:"), /* @__PURE__ */ jsx("div", {
    sel: ".overflow-icons",
    class: { "has-columns": hasLastViewed }
  }, icons), extraUsersCount ? /* @__PURE__ */ jsx("div", {
    sel: ".overflow-more-text.overflow-text"
  }, "+ ", extraUsersCount, " ", moreText) : null, editorUser && /* @__PURE__ */ jsx("div", {
    sel: ".overflow-editor-section"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".overflow-text"
  }, "Last edited ", editorUserName ? `by ${editorUserName}
` : ``, editorUser.dateStr))));
}
export function template() {
  var _a;
  const maxIcons = this.attr(`max-icons-displayed`) >= 0 ? this.attr(`max-icons-displayed`) : 0;
  const allUsers = this.attr(`users`) || [];
  const usersToShow = allUsers.slice(0, maxIcons).reverse();
  const overflowUsers = allUsers.slice(maxIcons, this.attr(`max-icons-total`));
  const extraUsersCount = (_a = this.attr(`user-count-override`)) != null ? _a : Math.max(allUsers.length - usersToShow.length, 0);
  const extraOverflowUsersCount = Math.max(extraUsersCount - overflowUsers.length, 0);
  const icons = usersToShow.map((user, index) => {
    return getIconEl(user, {
      "disable-tooltip": this.attr(`disable-tooltip`),
      "tooltip-placement": this.attr(`tooltip-placement`),
      size: this.attr(`size`),
      "track-properties": {
        [UserIconTrackingEventProperty.IconType]: index === 0 ? `creator` : `viewer`,
        [UserIconTrackingEventProperty.AccessPoint]: `creator-icon`,
        [UserIconTrackingEventProperty.ResourceType]: this.attr(`track-properties`)[TrackingEventProperty.ResourceType]
      }
    });
  });
  const moreText = extraUsersCount ? /* @__PURE__ */ jsx("div", {
    sel: ".more-text"
  }, /* @__PURE__ */ jsx("span", null, "+ ", extraUsersCount), /* @__PURE__ */ jsx(OverflowTooltip, {
    users: overflowUsers,
    extraUsersCount: extraOverflowUsersCount,
    moreText: this.attr(`more-text`),
    editorUser: this.attr(`editor-user`),
    trackingProps: this.attr(`track-properties`),
    onShowed: this.helpers.handleOverflowTooltipShowed
  })) : null;
  return /* @__PURE__ */ jsx("div", {
    sel: ".users-list"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".icon-container"
  }, icons), moreText);
}
